<template>
  <form @submit.prevent>
    <h6 class="heading-small text-muted mb-4">ข้อมูลอื่นๆ</h6>
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <label> ข้อมูลใบเสร็จ </label>
          <input
            type="text"
            class="form-control"
            placeholder="ข้อมูลใบเสร็จ"
            v-model="other.receipt" />
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label> ข้อมูลท้ายใบเสร็จ </label>
          <input
            type="text"
            class="form-control"
            placeholder="ข้อมูลท้ายใบเสร็จ"
            v-model="other.footerReceipt" />
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>Size ใบปะหน้า</label>
          <b-form-select
            v-model="other.sizeLabel"
            :options="size"></b-form-select>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>QR CODE</label>
          <input
            type="url"
            class="form-control"
            placeholder="ตัวอย่าง https://www.domain-name.com/"
            v-model="other.qrCode" />
        </div>
      </div>
    </div>
    <hr class="my-4" />
    <template v-if="$USER_LOGIN.get().isAdmin">
      <hr class="my-4" />
      <div class="mt-4 w-100 text-right">
        <b-button variant="secondary" @click="resetForm()">กรอกใหม่</b-button>
        <b-button type="submit" variant="info" @click="createOrUpdateOther()"
          >บันทึก</b-button
        >
      </div>
    </template>
  </form>
</template>

<script>
import { required, requiredIf, url } from "vuelidate/lib/validators";
import configPOPTheme from "@/config/POPTheme";
import validatePop from "@/plugins/validatePop.js";
import {
  showSuccessModal,
  showErrorModal,
} from "@/components/modalNotification.js";
export default {
  name: "BranceOther",
  props: {
    submittEdit: Boolean,
    other: Object,
  },
  data() {
    return {
      size: [
        { value: "A5", text: "A5" },
        { value: "A4", text: "A4" },
        { value: "A6", text: "A6" },
        { value: "receipt", text: "ใบเสร็จ" },
        { value: "letter", text: "ซองจดหมาย" },
        { value: "letter4x6", text: "ขนาด 4*6" },
        { value: "sticker", text: "ขนาดสติกเกอร์ 8x8 เซนติเมตร" },
        { value: "sticker4x6", text: "ขนาดสติกเกอร์ 4x6 นิ้ว" },
        { value: "paperang", text: "Paperang" },
      ],
      timePickupTHP: [
        { value: null, text: "เลือกเวลาเข้ารับพัสดุ" },
        { value: "12:00:00", text: "12:00" },
        { value: "13:00:00", text: "13:00" },
        { value: "14:00:00", text: "14:00" },
        { value: "15:00:00", text: "15:00" },
        { value: "16:00:00", text: "16:00" },
        { value: "17:00:00", text: "17:00" },
      ],
      configPOPTheme: configPOPTheme,
    };
  },
  validations: {
    other: {
      operationSystem: { required },
      operationSystemOther: {
        required: requiredIf(function (other) {
          return !this.disableOperationSystem() && this.mapOperationSystem();
        }),
      },
      pickupTHP: { required },
      timePickupTHP: {
        required: requiredIf(function (other) {
          return other.pickupTHP == "YES";
        }),
      },
      numsOrderTHP: {
        required: requiredIf(function (other) {
          return other.pickupTHP == "YES";
        }),
      },
      typeCarTHP: {
        required: requiredIf(function (other) {
          return other.pickupTHP == "YES";
        }),
      },
      qrCode: { url },
    },
  },
  methods: {
    clearInputOperationSystem(index) {
      if (this.optionsOperationSystem[index].item.hasOwnProperty("other")) {
        this.optionsOperationSystem[index].item["other"] = "";
        this.$refs["other"][0].value = "";
      }
    },
    mapInputOperationSystem(index, value) {
      let i = this.other.operationSystem.findIndex((system) => {
        return typeof system === "object" && system !== null;
      });
      if (i > -1) {
        this.other.operationSystem[i]["other"] = value;
      }
      this.optionsOperationSystem[index].item["other"] = value;
    },
    mapOperationSystem() {
      let index = this.optionsOperationSystem.findIndex((system) => {
        return system.key == "other";
      });
      if (
        index > -1 &&
        this.optionsOperationSystem[index].item["other"] == ""
      ) {
        return true;
      }
      return false;
    },
    disableOperationSystem() {
      return !this.other.operationSystem.some(
        (item) => Object.keys(item) == "other"
      );
    },
    createOrUpdateOther() {
      this.$emit("update:submittEdit", true);
      this.$v.other.$touch();
      if (this.$v.other.$invalid) {
        return false;
      }
      this.$emit("handleLoader");
      this.$http
        .post(
          this.$API_URL + "/shop/shop/detail",
          {
            type: "other",
            detail: this.other.receipt,
            footer_receipt: this.other.footerReceipt,
            default_label_size: this.other.sizeLabel,
            qrcode_receipt: this.other.qrCode,
            cctv: this.other.cctv,
            barcode_scanner: this.other.scanner,
            parking: this.other.parking,
            operating_system: this.other.operationSystem,
            sell_service: this.other.sellService,
            other_service: this.other.otherService,
            pickup_thp: this.other.pickupTHP,
            time_pickup_thp: this.other.timePickupTHP,
            nums_order_thp: this.other.numsOrderTHP,
            type_car_thp: this.other.typeCarTHP,
          },
          {
            headers: {
              Token: localStorage.getItem("access_token"),
            },
          }
        )
        .then((res) => {
          let checkError = validatePop(res);
          this.$emit("handleLoader");
          if (!checkError.status) {
            showErrorModal(checkError.msg);
            return false;
          }
          showSuccessModal("บันทึกข้อมูลอื่นๆสำเร็จ");
        })
        .catch((error) => {});
    },
    resetForm() {
      Object.keys(this.other).forEach((key) => {
        if (
          [
            "cctv",
            "scanner",
            "parking",
            "sellService",
            "otherService",
          ].includes(key)
        ) {
          this.other[key] = "YES";
        } else if (key == "operationSystem") {
          let i = this.other[key].findIndex((system) => {
            return typeof system === "object" && system !== null;
          });
          if (i > -1) {
            this.other[key][i]["other"] = "";
            this.$refs["other"][0].value = "";
          }
          this.other[key] = [];
        } else if (key == "sizeLabel") {
          this.other[key] = "A5";
        } else {
          this.other[key] = "";
        }
      });
    },
  },
  computed: {
    optionsOperationSystem() {
      return [
        { item: "android", name: "Android", key: "android" },
        { item: "ios", name: "IOS", key: "ios" },
        { item: "androidIos", name: "ทั้ง Android และ IOS", key: "androidIos" },
        { item: { other: "" }, name: "อื่นๆ โปรดระบุ", key: "other" },
      ];
    },
  },
};
</script>

<style></style>
